(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // Get products nav item and dropdown
    const productsNavItem = document.querySelector('[data-nav-item="products"]');
    const dropdown = document.getElementById('products-dropdown');
    const hoverTriangle = productsNavItem.querySelector('.hover-triangle');

    if (!productsNavItem || !dropdown || !hoverTriangle) {
      console.error('Missing required elements for dropdown menu');
      return;
    }

    // Initial state (not visible)
    dropdown.style.display = 'none';
    dropdown.style.opacity = '0';
    dropdown.style.transform = 'translateY(-20px)';

    let hoverTimeout = null;
    let isHovering = false;
    let isDropdownVisible = false;

    // Create the side triangles
    const leftTriangle = document.createElement('div');
    leftTriangle.className = 'side-triangle';
    leftTriangle.style.display = 'none';
    leftTriangle.style.height = '100%';
    leftTriangle.style.top = '0';
    leftTriangle.style.left = '-30px';

    const rightTriangle = document.createElement('div');
    rightTriangle.className = 'side-triangle';
    rightTriangle.style.display = 'none';
    rightTriangle.style.height = '100%';
    rightTriangle.style.top = '0';
    rightTriangle.style.right = '-30px';

    // Add side triangles to the nav item
    productsNavItem.appendChild(leftTriangle);
    productsNavItem.appendChild(rightTriangle);

    // Function to show the dropdown
    const showDropdown = () => {
      isDropdownVisible = true;

      // Show hover triangles
      hoverTriangle.style.display = 'block';
      leftTriangle.style.display = 'block';
      rightTriangle.style.display = 'block';

      // Make hover triangles interactive
      Motion.animate(hoverTriangle, { opacity: 1 }, { duration: 0.1 });

      // Show the dropdown
      dropdown.style.display = 'block';

      // Animate the dropdown
      Motion.animate(
        dropdown,
        {
          opacity: 1,
          y: 0,
        },
        {
          duration: 0.3,
          easing: 'ease-out',
        },
      );

      // Stagger animate the dropdown items
      const dropdownItems = dropdown.querySelectorAll('.dropdown-item');
      Motion.animate(
        dropdownItems,
        {
          opacity: [0, 1],
          y: [-10, 0],
        },
        {
          delay: Motion.stagger(0.05),
          duration: 0.4,
          easing: 'ease-out',
        },
      );
    };

    // Function to hide the dropdown
    const hideDropdown = () => {
      if (!isDropdownVisible) return;
      isDropdownVisible = false;

      // Hide hover triangles
      Motion.animate(
        hoverTriangle,
        { opacity: 0 },
        {
          duration: 0.1,
          onComplete: () => {
            hoverTriangle.style.display = 'none';
            leftTriangle.style.display = 'none';
            rightTriangle.style.display = 'none';
          },
        },
      );

      // Animate the dropdown out
      Motion.animate(
        dropdown,
        {
          opacity: 0,
          y: -10,
        },
        {
          duration: 0.2,
          easing: 'ease-in',
          onComplete: () => {
            dropdown.style.display = 'none';
          },
        },
      );
    };

    // Setup hover listeners for nav item
    productsNavItem.addEventListener('mouseenter', () => {
      isHovering = true;

      // Clear any existing timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
      }

      // Set timeout for 0.5 seconds before showing dropdown
      hoverTimeout = setTimeout(() => {
        // Only proceed if still hovering after delay
        if (!isHovering) return;
        showDropdown();
      }, 500); // 0.5 second delay
    });

    // Add click event to immediately show dropdown
    productsNavItem.querySelector('button').addEventListener('click', (e) => {
      e.preventDefault(); // Prevent any default button behavior

      // Clear any existing hover timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }

      // Immediately show the dropdown
      isHovering = true;
      showDropdown();
    });

    productsNavItem.addEventListener('mouseleave', (e) => {
      isHovering = false;

      // Calculate if the mouse is moving toward the dropdown
      const rect = productsNavItem.getBoundingClientRect();
      const isMovingDown = e.clientY > rect.bottom;

      // Clear any pending show animation timeout
      if (hoverTimeout) {
        clearTimeout(hoverTimeout);
        hoverTimeout = null;
      }

      // If moving down toward the dropdown, give a grace period
      // before hiding to let the user reach the dropdown content
      if (isMovingDown && isDropdownVisible) {
        hoverTimeout = setTimeout(() => {
          // Only hide if we're not hovering over the item, triangles, or dropdown
          if (!isHovering && !isMouseOverDropdown) {
            hideDropdown();
          }
        }, 150); // Small grace period
      } else {
        hideDropdown();
      }
    });

    // Track if mouse is over dropdown
    let isMouseOverDropdown = false;
    dropdown.addEventListener('mouseenter', () => {
      isMouseOverDropdown = true;
    });

    dropdown.addEventListener('mouseleave', () => {
      isMouseOverDropdown = false;
      hideDropdown();
    });

    // Add event listeners for hover triangle and side triangles
    [hoverTriangle, leftTriangle, rightTriangle].forEach((triangle) => {
      triangle.addEventListener('mouseenter', () => {
        // If mouse enters any triangle, consider us still hovering
        isHovering = true;

        // Clear any pending hide timeouts
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
      });

      triangle.addEventListener('mouseleave', (e) => {
        // If mouse is moving toward the dropdown, stay open
        const rect = triangle.getBoundingClientRect();
        const isMovingDown = e.clientY > rect.bottom;

        if (!isMovingDown || !isDropdownVisible) {
          isHovering = false;
          hideDropdown();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_megamenu"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // For handling mobile menu state persistence
    document.addEventListener('alpine:init', () => {
      Alpine.store('mobileNav', {
        open: false,
      });
    });

    // Add resize handler to close mobile menu when switching to desktop
    window.addEventListener('resize', () => {
      const isDesktop = window.matchMedia('(min-width: 768px)').matches;
      if (isDesktop) {
        // Check if Alpine is initialized and the store exists
        if (window.Alpine && Alpine.store('mobileNav')) {
          Alpine.store('mobileNav').open = false;
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
